class GPSProviderModel extends App.Models.BaseModel {
  modelUrl = 'GPSProvider';
}

App.Models.GPSProvider = GPSProviderModel;
